import gql from 'graphql-tag'

const vacanciesQuery = gql`
    query GetVacancies {
        vacancies {
            applicationURL
            displayText
            description
        }
    }
`

interface Vacancy {
    applicationURL: string | null;
    displayText: string;
    description: string;
}

export {
    vacanciesQuery,
    Vacancy
}